var currentCards = [];
var currentCardsTitles = [];
var currentCardsStyle = [];
var bannerBundlePack = document.querySelector("[data-banner-pack-bundle]");
var bundlePackButton = document.querySelector("[data-bundle-pack-button]");
var bundleAdd = document.querySelectorAll("[data-bundle-add]");
var bundleRemove = document.querySelectorAll("[data-bundle-remove]");
var bundlePackMessage = document.querySelector("[data-banner-pack-bundle-message]");
var bundlePackMessage2 = document.querySelector("[data-banner-pack-bundle-message2]");
var bundlePackArrow = document.querySelector("[data-banner-pack-bundle-arrow]");
var packProductNumber = "[data-pack-product-number]";
var iconBeerContainerHtml = document.querySelector(".bundle_side_block_icons-container").outerHTML;
var recapItemsCards = document.querySelector(".recap_items-cards");
var recapItemsCardsNbBeer = document.querySelector(".nb_beer");
var recapItemsCardsIconBeer = document.querySelector(".side_block_icon-mobile");
var cartIcon = document.querySelector("#cart-icon-bubble");
var bundleUnitPriceNbBeer = document.querySelector(".side_block_icons_mobile-price-unit span");
var cardTitles = document.querySelectorAll(".product-card__title a.card__title");
var fullPackMessage = document.querySelector('.collection-bundle__full-pack-message');
const singularProduct = bundlePackButton.getAttribute('data-singluar');
const pluralProduct = bundlePackButton.getAttribute('data-plural');


// price
var bannerPackBundlePrice = document.querySelector("[data-banner-pack-bundle-price]");
var bannerPackBundleDiscountedPrice = document.querySelector("[data-banner-pack-bundle-discounted-price]");
bannerPackBundleDiscountNumber = document.querySelector("[data-banner-pack-bundle-discount-number]")
// Mobile settings
//  var bannerPackBundlePerso = document.querySelector("[data-banner-pack-bundle-perso]");
var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

// Initialize bundle page
// if (sessionStorage.currentCardsTitles != undefined){
//     currentCardsTitles = sessionStorage.currentCardsTitles.split(",");
// }
// if (sessionStorage.currentCardsStyle != undefined){
//     currentCardsStyle = sessionStorage.currentCardsStyle.split(",");
// }
// if (sessionStorage.currentCards != undefined){
//     currentCards = JSON.parse(sessionStorage.currentCards);
//     recoverSessionStorage()
// }

bundleAdd.forEach((buttonAddPack, i) => {
    buttonAddPack.addEventListener("click", (el) => {
        if (currentCards.length < 5) {
            var data = buttonAddPack.dataset.bundleAdd;
            var title = buttonAddPack.dataset.title;
            var style = buttonAddPack.dataset.style;
            addCardTobundle(data, title, style, i, buttonAddPack);
            if (currentCards.length < 3) {
                bundlePackButton.disabled = true;
                bundlePackButton.innerHTML = `Ajouter encore ${3 - currentCards.length} ${(3 - currentCards.length) === 1 ? singularProduct : pluralProduct}`;
                bannerPackBundlePrice.style.display = 'none';
                bannerPackBundleDiscountedPrice.style.display = 'none';
                bannerPackBundleDiscountNumber.style.display = 'none';
            } else {
                bundlePackButton.disabled = false;
                bundlePackButton.innerHTML = `Ajouter au panier`
                bannerPackBundlePrice.style.display = 'block';
                bannerPackBundleDiscountedPrice.style.display = 'block';
                bannerPackBundleDiscountNumber.style.display = 'block';
            }
        }
    });
})

bundleRemove.forEach((buttonRemovePack, i) => {
    buttonRemovePack.addEventListener("click", (el) => {
        if (document.querySelectorAll("[data-pack-product-number]")[i].value != 0) {
            var data = buttonRemovePack.dataset.bundleRemove;
            console.log('data', buttonRemovePack, data)
            document.querySelectorAll("[data-pack-product-number]")[i].value = document.querySelectorAll("[data-pack-product-number]")[i].value - 1;
            document.querySelectorAll("[data-pack-product-number]")[i].setAttribute("value", document.querySelectorAll("[data-pack-product-number]")[i].value);
            removeCardTobundle(data);
            if (currentCards.length < 3) {
                bundlePackButton.disabled = true;
                bundlePackButton.innerHTML = `Ajouter encore ${3 - currentCards.length} ${(3 - currentCards.length) === 1 ? singularProduct : pluralProduct}`;
                bannerPackBundlePrice.style.display = 'none';
                bannerPackBundleDiscountedPrice.style.display = 'none';
                bannerPackBundleDiscountNumber.style.display = 'none';
            } else {
                bundlePackButton.disabled = false;
                bundlePackButton.innerHTML = `Ajouter au panier`;
                bannerPackBundlePrice.style.display = 'block';
                bannerPackBundleDiscountedPrice.style.display = 'block';
                bannerPackBundleDiscountNumber.style.display = 'block';
            }
        }
    });
})

function generateUniqueId() {
  return 'xxxx-xxxx-4xxx-yxxx-xxxx-xxxx-xxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

bundlePackButton.addEventListener("click", () => {
    // ADD BUNDLE TO CART
    var items = [];
    const uniqueId = generateUniqueId()
    currentCards.forEach((card, i) => {
        var cardJson = JSON.parse(card);
        var exist = false;
        if (!cardJson.properties) {
            cardJson.properties = {};
        }
        cardJson.properties["_pack_id"] = uniqueId;
        cardJson.properties["_pack"] = currentCards.length;
        if (items.length != undefined && items.length > 0) {
            items.forEach((item) => {
                if (parseInt(item.id) == parseInt(cardJson.id)) {

                    if (item.quantity == undefined) item.quantity = 1;
                    item.quantity = parseInt(item.quantity) + 1;
                    exist = true;
                } 
            });
            if (exist) return false;
        }
        items.push(cardJson);
    })
    let formData = {
        'items': items,
        'sections': ['cart-drawer']
    };
    
    // console.log("Form: ", formData);

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to add item to cart');
        }
        return response.json();
    })
    .then(responseData => {
        // console.log("Add to cart success:", responseData);
        // console.log('Updated cart data:', responseData);
        publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            cartData: responseData,
        });
        currentCards = [];
        bundlePackButton.disabled = true;
        bundlePackButton.innerHTML = `Ajouter encore ${3 - currentCards.length} ${(3 - currentCards.length) === 1 ? singularProduct : pluralProduct}`;
        bannerPackBundlePrice.style.display = 'none';
        bannerPackBundleDiscountedPrice.style.display = 'none';
        bannerPackBundleDiscountNumber.style.display = 'none';
        fullPackMessage.setAttribute('hidden', '');
        sessionStorage.removeItem("currentCards");
        sessionStorage.removeItem("currentCardsTitles");
        sessionStorage.removeItem("currentCardsStyle");
        RebootPage();
    })
    .catch(err => {
        console.error('Error adding to cart:', err);
        bundlePackButton.disabled = false;
    })
    .finally(() => {
        if (cart && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
        }
    });
})

// Remove product from bundle
function removeCardTobundle(data) {
    const index = currentCards.indexOf(data);

    
    if (index > -1) { // only splice array when item is found
        currentCards.splice(index, 1); // 2nd parameter means remove one item only
        currentCardsTitles.splice(index, 1);
        currentCardsStyle.splice(index, 1);
    }
    updatePackIcon();
    updatePrice();
    removeRecapItemsCards(data);
    updateNumbersOfBeerMobile()
    // dataStorage = localStorage.getItem(currentCards);
    sessionStorage.setItem("currentCards", JSON.stringify(currentCards));
    sessionStorage.setItem("currentCardsTitles", currentCardsTitles);
    sessionStorage.setItem("currentCardsStyle", currentCardsStyle);
}

// Add product to bundle
function addCardTobundle(data, title, style, i, buttonAddPack) {
    currentCards.push(data);
    
    currentCardsTitles.push(title);
    currentCardsStyle.push(style);
    updatePackIcon('add');
    updatePrice();
    updateNumbers();
    addRecapItemsCards(data, i, buttonAddPack);
    updateNumbersOfBeerMobile()
    // dataStorage = localStorage.getItem(currentCards);
    sessionStorage.setItem("currentCards", JSON.stringify(currentCards));
    sessionStorage.setItem("currentCardsTitles", currentCardsTitles);
    sessionStorage.setItem("currentCardsStyle", currentCardsStyle);
}
// Add recap items cards
function addRecapItemsCards(data, i, buttonAddPack) {
    var productImageUrl = JSON.parse(data).image;
    var productTitle, productStyle, productSubtitle;
    if (buttonAddPack != undefined) {
        productTitle = buttonAddPack.dataset.title;
        productSubtitle = JSON.parse(data).title;
        productStyle = buttonAddPack.dataset.style;
    } else {
        productTitle = currentCardsTitles[i];
        productStyle = currentCardsStyle[i];
    }
    productImageUrl = productImageUrl.replace(/width=\d+/, 'width=700');
    var cardId = `recap_items-card-${getRandomInt(0, 100000)}`;
    var cardHtml = `
        <div data-bundle='${data}' id="${cardId}" class="recap_items-card">
            <div class="recap_items_card-image-container">
                <img class="recap_items_card-image rounded" src="${productImageUrl}">
                <div class="skeleton"></div>
            </div>
            <div class="recap_items_card-infos">
                <p class="recap_items_card_infos-title">${productTitle}</p>
                <p class="recap_items_card_infos-subtitle">${productSubtitle}</p>
            </div>
            <div class="recap_items_card-remove">
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_5440_31726)">
                        <path d="M4.01909 14.4884L14.9159 3.59165L15.5098 4.18555L4.61299 15.0823L4.01909 14.4884ZM4.01909 4.21137L4.63882 3.59165L15.5356 14.4884L14.9159 15.1082L4.01909 4.21137Z" fill="#006D6C"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_5440_31726">
                            <rect width="18.57" height="18.57" fill="white" transform="translate(0.429688)"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>
        </div>`;
    
    recapItemsCards.insertAdjacentHTML('afterbegin', cardHtml);
    var drawerItemsContainer = document.querySelector(".collection-bundle__drawer-item");
    if (drawerItemsContainer) {
        drawerItemsContainer.insertAdjacentHTML('afterbegin', cardHtml);
    }

    var cards = document.querySelectorAll(`#${cardId}`);
    
    cards.forEach(function(cardElement) {
        var imageElement = cardElement.querySelector('.recap_items_card-image');
        var skeletonElement = cardElement.querySelector('.skeleton');
        imageElement.addEventListener('load', function() {
            skeletonElement.remove();
        });
    });

    removeRecapItemsCroseClose(cardId);
}

// Remove recap items cards
function removeRecapItemsCards(data) {
    var dataId = JSON.parse(data).id;
    var recapItemsCards = document.querySelectorAll(".recap_items-cards .recap_items-card");
    var drawerItemsCards = document.querySelectorAll(".collection-bundle__drawer-item .recap_items-card");
    
    for (let i = 0; i < recapItemsCards.length; i++) {
        if (JSON.parse(recapItemsCards[i].dataset.bundle).id == dataId) {
            recapItemsCards[i].remove();
            if (drawerItemsCards[i]) {
                drawerItemsCards[i].remove();
            }
            
            break;
        }
    }
}


// Remove recap items cards by close crose
function removeRecapItemsCroseClose(cardId) {
    var cardRecaps = document.querySelectorAll(`#${cardId}`);
    cardRecaps.forEach((cardRecap) => {
        var cardRecapRemove = cardRecap.querySelector('.recap_items_card-remove');

        cardRecapRemove.addEventListener("click", () => {
            var cardData = cardRecap.dataset.bundle;
            var cardDataId = JSON.parse(cardData).id;
            
            const index = currentCards.indexOf(cardData);
            if (index > -1) {
                currentCards.splice(index, 1);
                currentCardsTitles.splice(index, 1);
                currentCardsStyle.splice(index, 1);
                sessionStorage.setItem("currentCards", JSON.stringify(currentCards));
                sessionStorage.setItem("currentCardsTitles", currentCardsTitles);
                sessionStorage.setItem("currentCardsStyle", currentCardsStyle);
                updatePackIcon();
                updatePrice();

                const productCounts = document.querySelectorAll("[data-pack-product-number]");
                productCounts.forEach((count) => {
                    var cardProductId = JSON.parse(count.nextElementSibling.firstChild.nextElementSibling.dataset.bundleAdd).id;
                    if (cardProductId == cardDataId ) {
                        count.value = count.value - 1;
                        count.setAttribute("value", count.value - 1);
                    }
                });
            }

            var recapItemsCards = document.querySelectorAll(".recap_items-cards .recap_items-card");
            var drawerItemsCards = document.querySelectorAll(".collection-bundle__drawer-item .recap_items-card");

            for (let i = 0; i < recapItemsCards.length; i++) {
                if (JSON.parse(recapItemsCards[i].dataset.bundle).id == cardDataId) {
                    recapItemsCards[i].remove();
                    if (drawerItemsCards[i]) {
                        drawerItemsCards[i].remove();
                    }
                    break;
                }
            }
            
            updateNumbersOfBeerMobile();
            if (currentCards.length < 3) {
                bundlePackButton.disabled = true;
                bundlePackButton.innerHTML = `Ajouter encore ${3 - currentCards.length} ${(3 - currentCards.length) === 1 ? singularProduct : pluralProduct}`;
                bannerPackBundlePrice.style.display = 'none';
                bannerPackBundleDiscountedPrice.style.display = 'none';
                bannerPackBundleDiscountNumber.style.display = 'none';
            } else {
                bundlePackButton.disabled = false;
                bundlePackButton.innerHTML = `Ajouter au panier`;
                bannerPackBundlePrice.style.display = 'block';
                bannerPackBundleDiscountedPrice.style.display = 'block';
                bannerPackBundleDiscountNumber.style.display = 'block';
            }
        });
    });
}

// Update Selector QTY
function updateNumbers() {
    document.querySelectorAll(".quantity-selector").forEach(qtySelector => {
        var number = 0;
        var selectorQtyAdd = qtySelector.querySelector("[data-bundle-add]");
        if (selectorQtyAdd) {
            var selectorQtyAddId = JSON.parse(selectorQtyAdd.dataset.bundleAdd).id;
            currentCards.forEach(obj => {
                var data = JSON.parse(obj);
                if (data.id === selectorQtyAddId) {
                    number++;
                }
            });
            var packProductNumber = qtySelector.querySelector("[data-pack-product-number]");

            if (packProductNumber) {
                packProductNumber.value = number;
                packProductNumber.setAttribute("value", number)
            }
        }
    });
}


// Update Label QTY Mobile
function updateNumbersOfBeerMobile() {
    recapItemsCardsNbBeer.innerText = currentCards.length * 1;
    bundleUnitPriceNbBeer.innerText = currentCards.length * 1;

}



// Update Beer svg Fill
function updatePackIcon(addOrRemove) {
    // var bundleIcons = document.querySelectorAll("[data-banner-pack-icon]");
    // var iconBeerContainers = document.querySelectorAll(".bundle_side_block_icons-container");
    // var iconBeerContainer =  iconBeerContainers[iconBeerContainers.length - 1];

    if (addOrRemove == "add") {
        var bundleIcons = document.querySelectorAll("[data-banner-pack-icon]");
        bundleIcons.forEach((icon, i) => {
            if (currentCards.length == (i + 1)) {
                icon.classList.add('fill_blue')
            }
        })

        var bundleIconsMobile = document.querySelectorAll("[data-banner-pack-icon-mobile]");
        bundleIconsMobile.forEach((icon, i) => {
            if (currentCards.length == (i + 1)) {
                icon.classList.add('fill_blue')
            }
        })
        if (currentCards.length == 5 || currentCards.length == 10 || currentCards.length == 15) {
            // iconBeerContainer.insertAdjacentHTML( 'afterend', iconBeerContainerHtml )
        }
    } else if (addOrRemove == "initialize") {
        if (currentCards.length >= 5 || currentCards.length >= 10 || currentCards.length >= 15) {
            // iconBeerContainer.insertAdjacentHTML( 'afterend', iconBeerContainerHtml )
        }
        var bundleIcons = document.querySelectorAll("[data-banner-pack-icon]");
        bundleIcons.forEach((icon, i) => {
            if ((i + 1) <= currentCards.length) {
                icon.classList.add('fill_blue');
            }
        })
        var bundleIconsMobile = document.querySelectorAll("[data-banner-pack-icon-mobile]");
        bundleIconsMobile.forEach((icon, i) => {
            if ((i + 1) <= currentCards.length) {
                icon.classList.add('fill_blue')
            }
        })
    } else {
        var bundleIconsFillBlue = document.querySelectorAll(".bundle_side_block_icons-container .fill_blue");
        // console.log(bundleIconsFillBlue.length);
        bundleIconsFillBlue[bundleIconsFillBlue.length - 1].classList.remove('fill_blue');

        var bundleIconsFillBlueMobile = document.querySelectorAll(".collection_bundle_side_block_icons_mobile-pack-infos .fill_blue");
        // console.log(bundleIconsFillBlue.length);
        bundleIconsFillBlueMobile[bundleIconsFillBlueMobile.length - 1].classList.remove('fill_blue');
    }
}

function updatePrice() {
    var price = 0;
    currentCards.forEach(card => {
        var floatPrice = JSON.parse(card).price.replace(",", ".");
        price = price + parseFloat(floatPrice);
    })
    price = price.toFixed(2)
    priceBeforeDiscount = price.toString().replace(".", ",") + "€";
    priceBeforeDiscount = priceBeforeDiscount.replace(",€", "€");
    
    bannerPackBundlePrice.innerHTML = priceBeforeDiscount;

    if (currentCards.length == 3) {
        let tenPercent = price * 0.10;
        let tenPercentResult = (price - tenPercent).toFixed(2).toString().replace(".", ",") + "€";
        bannerPackBundleDiscountedPrice.innerHTML = tenPercentResult.replace(",€", "€");
        bannerPackBundleDiscountNumber.innerHTML = '-10%';
    } else if (currentCards.length == 4) {
        let fifteenPercent = price * 0.15;
        let fifteenPercentResult = (price - fifteenPercent).toFixed(2).toString().replace(".", ",") + "€";
        bannerPackBundleDiscountedPrice.innerHTML = fifteenPercentResult.replace(",€", "€");
        bannerPackBundleDiscountNumber.innerHTML = '-15%';
    } else if (currentCards.length == 5) {
        let twentyPercent = price * 0.20;
        let twentyPercentResult = (price - twentyPercent).toFixed(2).toString().replace(".", ",") + "€";
        bannerPackBundleDiscountedPrice.innerHTML = twentyPercentResult.replace(",€", "€");
        bannerPackBundleDiscountNumber.innerHTML = '-20%';
    }
    if (currentCards.length >= 5) {
        fullPackMessage.removeAttribute('hidden');
    } else {
        fullPackMessage.setAttribute('hidden', '');
    }
}

// Generate random number
function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
}

// Initialize bundle page
function recoverSessionStorage() {
    updatePackIcon("initialize");
    updatePrice();
    updateNumbers();
    updateNumbersOfBeerMobile()
    currentCards.forEach((data, i) => {

        addRecapItemsCards(data, i);
    });
    if (currentCards.length < 3) {
        bundlePackButton.disabled = true;
        bundlePackButton.innerHTML = `Ajouter encore ${3 - currentCards.length} ${(3 - currentCards.length) === 1 ? singularProduct : pluralProduct}`;
        bannerPackBundlePrice.style.display = 'none';
        bannerPackBundleDiscountedPrice.style.display = 'none';
        bannerPackBundleDiscountNumber.style.display = 'none';
    } else {
        bundlePackButton.disabled = false;
        bundlePackButton.innerHTML = `Ajouter au panier`;
        bannerPackBundlePrice.style.display = 'block';
        bannerPackBundleDiscountedPrice.style.display = 'block';
        bannerPackBundleDiscountNumber.style.display = 'block';
    }
    // console.log("ok");
}

// Reboot bundle page
function RebootPage() {
    //Update price to 0
    bannerPackBundlePrice.innerHTML = "0,00 €";

    // Update Label QTY Mobile to 0
    bundleUnitPriceNbBeer.innerText = 0;
    recapItemsCardsNbBeer.innerText = 0;

    //Update beerIcon BG
    var bundleIcons = document.querySelectorAll("[data-banner-pack-icon]");
    bundleIcons.forEach((icon) => {
        icon.classList.remove('fill_blue');
    });
    var bundleIconsMobile = document.querySelectorAll("[data-banner-pack-icon-mobile]");
        bundleIconsMobile.forEach((icon) => {
            icon.classList.remove('fill_blue')
        })
    var iconBeerContainers = document.querySelectorAll(".bundle_side_block_icons-container");
    iconBeerContainers.forEach((iconBeerContainer, i) => {
        // console.log(i);
        if (i > 0){
            iconBeerContainer.remove();
        }
    });

    // Update Selector QTY to 0
    document.querySelectorAll(".quantity-selector").forEach(qtySelector => {
        qtySelector.querySelector(packProductNumber).value = 0;
        qtySelector.setAttribute("value", 0)
    });

    // Remove all recap items cards
    var recapItemsCard = document.querySelectorAll(".recap_items-card");
    recapItemsCard.forEach(card => {
        card.remove();
    });
    
}

class BundleDrawer extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.querySelector('.collection-bundle__drawer-mob').addEventListener('click', () => {
            this.querySelector('.collection-bundle__drawer-mob').classList.toggle('active');
            const correspondingDrawer = this.querySelector('.collection-bundle__drawer');
            if (correspondingDrawer) {
                correspondingDrawer.classList.toggle('active');
            }
        });
        this.querySelector('.collection-bundle__drawer .icon-close').addEventListener('click', () => {
            this.querySelector('.collection-bundle__drawer-mob').classList.remove('active');
            const correspondingDrawer = this.querySelector('.collection-bundle__drawer');
            if (correspondingDrawer) {
                correspondingDrawer.classList.remove('active');
            }
        });
    }
}

customElements.define('bundle-drawer', BundleDrawer);

// variants

customElements.define(
    'variant-selector',
    class variantSelector extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
  
      init() {
        const selector = this.querySelector('.variant-select');
        const priceText = this.parentElement.parentElement.parentElement.querySelector('.price__regular .price-item');
        const images = this.parentElement.parentElement.parentElement.querySelectorAll('.product-card__image');
        const numberInput = this.parentElement.querySelector('.quantity-selector__input');
        const plusInput = this.parentElement.querySelector('[data-bundle-add]');
        const minusInput = this.parentElement.querySelector('[data-bundle-remove]');

        selector.addEventListener('change', () => {
            const newId = selector.value;
            const newVariantTitle = selector.querySelector('option:checked').getAttribute('data-variant-title');
            const newPrice = selector.querySelector('option:checked').getAttribute('data-price');
            const newPriceText = selector.querySelector('option:checked').getAttribute('data-price-currency');
            let newImage = null;
            if (selector.querySelector('option:checked').hasAttribute('data-image')) {
                newImage = selector.querySelector('option:checked').getAttribute('data-image');
            }

            images.forEach(image => {
                image.classList.add('hide');
                // console.log(`image_${newId}`)
                if (image.hasAttribute('id') && image.getAttribute('id') === `image_${newId}`) {
                    image.classList.remove('hide');
                }
            });

            priceText.innerHTML = newPriceText;

            numberInput.setAttribute('data-id', newId);
            plusInput.setAttribute('data-id', newId);
            minusInput.setAttribute('data-id', newId);

            let currentCardNumber = 0
            currentCards.forEach(card => {
                const parsedCard = JSON.parse(card)
                // console.log(parsedCard);
                if (parsedCard.id == newId) {
                    currentCardNumber += 1;
                }
            });
            numberInput.value = currentCardNumber;

            let bundleDataAdd = JSON.parse(plusInput.getAttribute('data-bundle-add'));
            bundleDataAdd.id = newId;
            bundleDataAdd.price = newPrice;
            bundleDataAdd.title = newVariantTitle;
            if (newImage) {
                bundleDataAdd.image = newImage;
            }
            plusInput.setAttribute('data-bundle-add', JSON.stringify(bundleDataAdd));

            let bundleDataRemove = JSON.parse(minusInput.getAttribute('data-bundle-remove'));
            bundleDataRemove.id = newId;
            bundleDataRemove.price = newPrice;
            bundleDataRemove.title = newVariantTitle;
            if (newImage) {
                bundleDataRemove.image = newImage;
            }
            minusInput.setAttribute('data-bundle-remove', JSON.stringify(bundleDataRemove));
        })
      }
    }
)